module.exports = __webpack_public_path__ + "img/logo.f13bcd63.png";